import { JurisdictionsEnum } from '@libs/backend-common';
import { getJurisdictionBaseUrl } from '@libs/helpers';
import DepositCryptoSteps from '../faq-steps/DepositCryptoSteps';
import DepositFiatSteps from '../faq-steps/DepositFiatSteps';
import RegistrationSteps from '../faq-steps/RegistrationSteps';
import WithdrawCryptoSteps from '../faq-steps/WithdrawCryptoSteps';
import WithdrawFiatSteps from '../faq-steps/WithdrawFiatSteps';
export const DEPOSIT_QUESTIONS = [
    {
        id: '01',
        question: 'landing_faq_fiat_deposit_steps_title',
        component: DepositFiatSteps,
    },
    {
        id: '02',
        question: 'landing_faq_crypto_deposit_steps_title',
        component: DepositCryptoSteps,
    },
];
export const WITHDRAW_QUESTIONS = [
    {
        id: '01',
        question: 'landing_faq_fiat_withdraw_steps_title',
        component: WithdrawFiatSteps,
    },
    {
        id: '02',
        question: 'landing_faq_crypto_withdraw_steps_title',
        component: WithdrawCryptoSteps,
    },
];
export const FREQUENTLY_ASKED_QUESTIONS = [
    {
        id: '01',
        question: 'landing_faq_question_two',
        answer: ['landing_faq_answer_two'],
    },
    {
        id: '02',
        question: 'landing_faq_question_one',
        answer: ['landing_faq_answer_one'],
    },
    {
        id: '03',
        question: 'landing_faq_question_five',
        answer: ['landing_faq_answer_five'],
    },
    {
        id: '04',
        question: 'landing_faq_question_three',
        answer: ['landing_faq_answer_three'],
    },
    {
        id: '05',
        question: 'landing_faq_question_four',
        answer: ['landing_faq_answer_four'],
    },
];
export const REGISTRATION_STEPS = [
    {
        id: '01',
        question: 'common_registration_verification',
        component: RegistrationSteps,
    },
];
export const LANDING_HOME_QUESTIONS = [
    {
        id: '01',
        question: 'home_faq_question_one',
        answer: ['home_faq_answer_one'],
    },
    {
        id: '02',
        question: 'home_faq_question_two',
        answer: ['home_faq_answer_two'],
    },
    {
        id: '03',
        question: 'home_faq_question_three',
        answer: ['home_faq_answer_three'],
    },
    {
        id: '04',
        question: 'home_faq_question_four',
        answer: ['home_faq_answer_four'],
    },
    {
        id: '05',
        question: 'home_faq_question_five',
        answer: ['home_faq_answer_five'],
    },
];
const BITNET_QUESTIONS = DEPOSIT_QUESTIONS.concat(REGISTRATION_STEPS, WITHDRAW_QUESTIONS, FREQUENTLY_ASKED_QUESTIONS);
const CREXONE_QUESTION = [
    {
        id: '01',
        question: 'landing_swap_faq_question_one',
        answer: [
            'landing_swap_faq_answer_one',
            'landing_swap_faq_answer_one_part_two',
            'landing_swap_faq_answer_one_part_three',
        ],
    },
    {
        id: '02',
        question: 'landing_swap_faq_question_two',
        answer: ['landing_swap_faq_answer_two'],
    },
    {
        id: '03',
        question: 'landing_swap_faq_question_three',
        answer: ['landing_swap_faq_answer_three'],
    },
    {
        id: '04',
        question: 'landing_swap_faq_question_four',
        answer: ['landing_swap_faq_answer_four'],
    },
    {
        id: '05',
        question: 'landing_swap_faq_question_five',
        answer: ['landing_swap_faq_answer_five'],
    },
    {
        id: '06',
        question: 'landing_swap_faq_question_six',
        answer: ['landing_swap_faq_answer_six'],
    },
    {
        id: '07',
        question: 'landing_swap_faq_question_seven',
        answer: [
            'landing_swap_faq_answer_seven',
            'landing_swap_faq_answer_seven_part_two',
            'landing_swap_faq_answer_seven_part_three',
        ],
    },
    {
        id: '08',
        question: 'landing_swap_faq_question_eight',
        answer: [
            'landing_swap_faq_answer_eight',
            'landing_swap_faq_answer_eight_part_two',
            'landing_swap_faq_answer_eight_part_three',
            'landing_swap_faq_answer_eight_part_four',
            'landing_swap_faq_answer_eight_part_five',
        ],
    },
];
// NOTE: does not need env arg
const { jurisdictionId } = getJurisdictionBaseUrl();
export const FAQ_QUESTION = jurisdictionId === JurisdictionsEnum.UA ? CREXONE_QUESTION : BITNET_QUESTIONS;
export const MAIN_PAGE_FAQ = [
    {
        id: '01',
        question: 'landing_faq_first_question',
        answer: ['landing_faq_first_answer'],
    },
    {
        id: '02',
        question: 'landing_faq_second_question',
        answer: ['landing_faq_second_answer'],
    },
    {
        id: '03',
        question: 'landing_faq_third_question',
        answer: ['landing_faq_third_answer'],
    },
    {
        id: '04',
        question: 'landing_faq_fourth_question',
        answer: ['landing_faq_fourth_answer'],
    },
    {
        id: '05',
        question: 'landing_faq_fifth_question',
        answer: ['landing_faq_fifth_answer'],
    },
];
//# sourceMappingURL=faqQuestions.js.map